import { memo } from 'react';
import AddSegmentButton from './AddSegmentButton';
import SegmentTransitionButton from '../SegmentTransition/SegmentTransitionButton';
import type { SegmentGapActionsProps } from './types';

const ROW_CENTERED = 'relative flex min-h-8 shrink-0 items-center justify-center';
const ROW_FULL = 'relative h-8 flex min-h-8 w-full shrink-0 items-center justify-center';
const SPACER = 'h-8 min-h-8';

function SegmentGapActions({
  previousSegment,
  nextSegment,
  isTransitionApplied,
  showAddSegmentRow,
  isSegmentTransitionsEnabled,
  showTransitionOnlyMenu = false
}: SegmentGapActionsProps) {
  const showAddRow = (showAddSegmentRow && previousSegment) || showTransitionOnlyMenu;
  const transitionButton = isSegmentTransitionsEnabled && (
    <SegmentTransitionButton
      previousSegment={previousSegment ?? undefined}
      nextSegment={nextSegment ?? undefined}
      isTransitionApplied={isTransitionApplied}
    />
  );

  return (
    <div className="relative min-h-full self-stretch" data-testid="segment-gap-actions">
      <div className="group absolute inset-0 -left-0.5 z-10 flex w-1 flex-col items-center justify-center">
        {showAddRow && (
          <div className={isTransitionApplied ? `${ROW_FULL} mb-1` : ROW_CENTERED}>
            <AddSegmentButton
              previousSegment={previousSegment ?? null}
              nextSegment={nextSegment ?? undefined}
              isTransitionApplied={isTransitionApplied}
              showUploadOption={!showTransitionOnlyMenu}
            />
          </div>
        )}
        {!showAddRow && isTransitionApplied && <div className={SPACER + ' mb-1'} />}
        {transitionButton && <div className={isTransitionApplied ? ROW_FULL : ROW_CENTERED}>{transitionButton}</div>}
        {isTransitionApplied && <div className={SPACER} />}
      </div>
    </div>
  );
}

export default memo(SegmentGapActions);
